export enum CardPaymentType {
    PINPAD,
    VIRTUAL,
    DATAFONO,
}

